import { render } from "./BecomeDealerButton.vue?vue&type=template&id=8c352e54&ts=true"
import script from "./BecomeDealerButton.vue?vue&type=script&lang=ts"
export * from "./BecomeDealerButton.vue?vue&type=script&lang=ts"

import "./BecomeDealerButton.vue?vue&type=style&index=0&id=8c352e54&lang=scss"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/marlu-store-locator-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__